/**
 * Рядки доплат — під товарами покупця, а не над ними.
 *
 * ⛔ Shopify ставить щойно додану позицію ПЕРШОЮ, а термобокс і застава за тару
 * додаються скриптом уже після товару. Через це кошик відкривався так:
 *
 *     Termoupakowanie              19,00 zł   ← 941 px від верху на телефоні
 *     Kaucja 0,50 zł BUTELKA…       0,50 zł
 *     Kiełbasa Salami…             28,90 zł   ← перший СВІЙ товар на 1433 px
 *
 * Тобто перше, що бачив покупець у власному кошику, — дві доплати, яких він не
 * замовляв. Заміряно 27.08.2026 на живому кошику.
 *
 * Тут ці рядки переставляються в кінець і позначаються як доплата. Лічильник
 * кількості з них прибирається: скрипт кауції однаково поверне потрібне число
 * (спроба поставити 4 термобокси поверталась до 1), тож стрілки лише вводили
 * в оману.
 *
 * ⚠️ Нічого не видаляємо і не міняємо в самому кошику — тільки порядок і вигляд.
 */
(function () {
  'use strict';

  // ті самі варіанти, що в assets/wxm-kaucja-tandem.js
  var FEE_VARIANT_IDS = [53750593061203, 53750592897363, 54104470323539];

  function isFeeRow(row) {
    var link = row.querySelector('a[href*="variant="]');
    if (!link) return false;
    var m = /variant=(\d+)/.exec(link.getAttribute('href') || '');
    return !!m && FEE_VARIANT_IDS.indexOf(parseInt(m[1], 10)) !== -1;
  }

  function tidy(row) {
    if (row.getAttribute('data-wxm-fee') === '1') return;
    row.setAttribute('data-wxm-fee', '1');
    // лічильник кількості на доплаті — оманливий: число тримає скрипт
    row.querySelectorAll('quantity-input, .quantity, cart-remove-button, .cart-item__quantity-wrapper')
      .forEach(function (el) { el.style.display = 'none'; });
  }

  function reorder() {
    var containers = new Set();
    var rows = document.querySelectorAll('tr.cart-item, .cart-item');
    rows.forEach(function (row) {
      if (!isFeeRow(row)) return;
      tidy(row);
      if (row.parentElement) containers.add(row.parentElement);
    });
    containers.forEach(function (box) {
      var fees = [].slice.call(box.children).filter(function (n) {
        return n.getAttribute && n.getAttribute('data-wxm-fee') === '1';
      });
      // у кінець, зберігаючи їхній взаємний порядок
      fees.forEach(function (n) { box.appendChild(n); });
    });
  }

  function start() {
    reorder();
    // кошик перемальовується після кожної зміни кількості — стежимо за цим
    var target = document.querySelector('cart-items, cart-drawer, #main-cart-items, body');
    if (!target || !window.MutationObserver) return;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; reorder(); });
    }).observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('cart:updated', reorder);
})();
